import axios from 'axios'

export const cepApi = {

    getAddress({ cep } = {}) {
        return axios
            .get('https://viacep.com.br/ws/'+ cep + '/json/')
            .then((response) => {
                return response.data
            })
    },

}
